module.exports = __webpack_public_path__ + "static/far-cry_plate-069e841890836318fbc7e0aa620a711b.png";